import type { TypePolicies } from '@apollo/client';
import { apolloCacheConfig } from '@crehana/apollo-client';

export const NOTIFICATION_HUB_TYPE_POLICIES: TypePolicies = {
  NotificationHubQueries: { merge: true },
  NotificationHubWhatsappTemplatesQueries: { merge: true },
};

apolloCacheConfig.policies.addTypePolicies(NOTIFICATION_HUB_TYPE_POLICIES);
